import FormSelector from "./paramsFormComponents/formSelector";
import { resolveVueInject } from "../../../lib/utils/vue";
import { INJECT_UICORE_FORM } from "../../../lib/utils/consts";
export const validateFormAtom = {
  id: 'uicore:validateForm',
  name: '校验表单',
  category: '逻辑',
  paramsSchema: {
    type: 'object',
    fields: [{
      id: 'target',
      type: 'string',
      title: '校验范围',
      'uc:allowExpr': false,
      ui: {
        type: 'formSelector'
      }
    }, {
      id: 'errorMessage',
      type: 'string',
      title: '校验失败文案',
      default: '请按要求填写完整信息',
      description: '文案中使用 `<reason>` 插入具体的失败原因，可能有多行。注意这里是尖括号',
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }, {
      id: 'abortIfRejected',
      type: 'boolean',
      title: '校验失败，就不执行后续步骤',
      default: true
    }]
  },
  returnValue: '校验通过与否(true/false)',
  paramsFormComponents: [{
    id: 'formSelector',
    component: FormSelector,
    propsSchema: {
      type: 'null'
    }
  }],
  execute: async (ctx, params) => {
    var _form;
    const {
      renderer,
      target
    } = ctx;
    let form;
    // eslint-disable-next-line eqeqeq
    if (params.target === '<root>' || params.target == null) {
      form = renderer.ucRootForm;
    } else if (!params.target) {
      form = target ? resolveVueInject(target.$parent, INJECT_UICORE_FORM) : renderer.ucRootForm;
    } else {
      form = renderer.getRef(params.target);
    }
    if (typeof ((_form = form) === null || _form === void 0 ? void 0 : _form.validate) !== 'function') throw new Error('无法确定表单校验范围');
    const errors = await form.validate();
    if (errors.length) {
      const uc = ctx.uc;
      const msg = params.errorMessage.replace('<reason>', errors.map(it => {
        var _it$editor;
        let msg = String(it.message);
        const label = (_it$editor = it.editor) === null || _it$editor === void 0 || (_it$editor = _it$editor.ucForm) === null || _it$editor === void 0 ? void 0 : _it$editor.label; // 补上输入框所属的 FormItem Label
        if (label) msg = `${label}: ${msg}`;
        return msg;
      }).join('\n')).trim();
      if (msg) uc.$message.error(msg);
      if (params.abortIfRejected) ctx.abort();
      return false;
    }
    return true;
  }
};
//# sourceMappingURL=validateFormAtom.js.map
